import { render, staticRenderFns } from "./VoucherTable.vue?vue&type=template&id=6a0a8453&"
import script from "./VoucherTable.vue?vue&type=script&lang=js&"
export * from "./VoucherTable.vue?vue&type=script&lang=js&"
import style0 from "./VoucherTable.vue?vue&type=style&index=0&id=6a0a8453&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports